     $(document).ready(function(){
      $('.home-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
       
      });
    $('.product-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 600,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });

       $('.free-of-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 600,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          }
        ]
      });
       $('.big-results-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 600,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
  
       
	
        var li = $(".curly-heroes .product-tabs .tabs-btns li");
  
         li.click(function(){
          var target = $(this).data("target");
           $(li).removeClass('active');
           $('.curly-heroes .product-tabs .tab-container').removeClass('active');
           $(target).addClass('active')
           $(this).addClass('active')

         });

        
      });

 var acc = document.getElementsByClassName("accordion");
   var panel = document.getElementsByClassName('panel');
   
   for (var i = 0; i < acc.length; i++) {
       acc[i].onclick = function() {
           var setClasses = !this.classList.contains('active');
           setClass(acc, 'active', 'remove');
           setClass(panel, 'show', 'remove');
   
           if (setClasses) {
               this.classList.toggle("active");
               this.nextElementSibling.classList.toggle("show");
           }
       }
   }
function setClass(els, className, fnName) {
       for (var i = 0; i < els.length; i++) {
           els[i].classList[fnName](className);
       }
   }